<script>
import ImageTile from '@/components/ImageTile'
import UrlJoin from 'url-join'

export default
{
    name: 'store-card',

    props:
    {
        store: { type: Object, required: true }
    },

    created ()
    {
    },

    render () 
    {
        return (
            <div class='store-card'>
                <image-tile on-click={this.onClick} title={this.store.name}
                    background-image={this.lowResBackgroundImage} strong-filter-shadow={true} />
            </div>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
        lowResBackgroundImage ()
        {
            return UrlJoin(this.store.pictures[0], '?width=500')
        }
    },

    methods:
    {
        onClick ()
        {
            this.$router.push({path: `stores/${this.store.id}`, query: { whileFetchingImage: this.lowResBackgroundImage }})
        }
    },

    components:
    {
        ImageTile
    }
}
</script>

<style lang='less'>
.store-card
{
    .image-tile
    {
        padding: 25px 0;
        border-radius: 14px;

        .tile-inside .subtitle
        {
            
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/StoreCard.vue